import interceptor from '@/plugins/interceptor';
const pathController = '/Importer'
export default {
  state: () => ({
  }),
  actions: {
    async importer_importAdmicomDB({ dispatch }, model) {
      try {
        await interceptor.authenticate.postFile(`${process.env.VUE_APP_API_URL}${pathController}/importAdmicomDB`, model);
        dispatch('notifications_create', {text: window.vueApp.$t('notifications.import'), title: window.vueApp.$t('left_menu.settings.import_database')});
      } catch (error) {
        dispatch('notifications_create', {text: `${window.vueApp.$t('notifications.general')} ${error.response.data ? window.vueApp.$t(`notifications.validation.${error.response.data}`) : error.message}`, title: window.vueApp.$t('left_menu.settings.import_database'), error: true});
        throw new Error(error);
      }
    },
    async importer_importINE({ dispatch }, model) {
      try {
        await interceptor.authenticate.postFile(`${process.env.VUE_APP_API_URL}${pathController}/importINE`, model);
        dispatch('notifications_create', {text: window.vueApp.$t('notifications.import'), title: window.vueApp.$t('left_menu.spot_programming.import')});
      } catch (error) {
        dispatch('notifications_create', {text: `${window.vueApp.$t('notifications.general')} ${error.response.data ? window.vueApp.$t(`notifications.validation.${error.response.data}`) : error.message}`, title: window.vueApp.$t('left_menu.spot_programming.import'), error: true});
        throw new Error(error);
      }
    },
    async importer_importRTC({ dispatch }, model) {
      try {
        await interceptor.authenticate.postFile(`${process.env.VUE_APP_API_URL}${pathController}/importRTC`, model);
        dispatch('notifications_create', {text: window.vueApp.$t('notifications.import'), title: window.vueApp.$t('left_menu.spot_programming.import')});
      } catch (error) {
        dispatch('notifications_create', {text: `${window.vueApp.$t('notifications.general')} ${error.response.data ? window.vueApp.$t(`notifications.validation.${error.response.data}`) : error.message}`, title: window.vueApp.$t('left_menu.spot_programming.import'), error: true});
        throw new Error(error);
      }
    }
  }
}

